import { Component, OnInit } from '@angular/core';
import { SharedServiceRegistry } from '../../shared-service-registry';
import { CoreServiceRegistry } from '../../../core/core-service-registry';
import { SearchService } from '../../search/search.service';
import { SearchParams } from '../../search/models/search-params.model';
import { SearchStatus } from '../../search/models/search-status.model';
import { TableRow } from './../../search/models/table-row.model';
import { UserPreferenceEvent, DELETE_SEARCH } from '../../models/user-favourite-event';
import { DataTableConfig } from '../../search/models/data-table-config';
import { SearchCriteriaCellRendererComponent } from './search-criteria-cell-renderer/search-criteria-cell-renderer.component';
import { DataTableEditorService } from './../../search/results/data-table-editor.service';
import { SearchCriteriaCellEditorComponent } from './search-criteria-cell-editor/search-criteria-cell-editor.component';

@Component({
  selector: 'lfwms-search-criteria-popup',
  templateUrl: './search-criteria-popup.component.html',
  styleUrls: ['./search-criteria-popup.component.css']
})
export class SearchCriteriaPopupComponent implements OnInit {

  private searchParams: SearchParams;
  private searchStatus: SearchStatus;
  public isLoading: boolean = true;
  public searchService: SearchService;
  public displayMode: string  = 'V';

  constructor(private coreServiceRegistry: CoreServiceRegistry,
      private sharedServiceRegistry: SharedServiceRegistry,
      private dataEditor: DataTableEditorService) {
  }

  public ngOnInit() {
    this.searchParams = new SearchParams();
    this.searchParams.tableId = 'searchcriteriatd';
    this.searchParams.tableEditor = this.dataEditor;
    this.searchParams.dataTableConfig = new DataTableConfig();
    this.searchParams.dataTableConfig
      .columnRendererMapping['searchName'] = SearchCriteriaCellRendererComponent;
    this.searchParams.dataTableConfig.editable = true;
    this.searchParams.dataTableConfig.autoTriggerEdit = false;
    this.searchParams.dataTableConfig.suppressClickEdit = true;
    this.searchParams.dataTableConfig.supportFiltering = true;
    this.searchParams.dataTableConfig
      .columnEditorMapping['searchName'] = SearchCriteriaCellEditorComponent;
    this.searchStatus = new SearchStatus();
    this.searchService = this.sharedServiceRegistry
      .createSearchService(this.searchParams, this.searchStatus);
    this.searchService.fetchMetadata()
      .subscribe(() => {
        this.searchService.setSearchCriteria({
          conditions: []
        });
        this.searchService.performSearch();
        this.isLoading = false;
      });
  }

  public deleteSearchCriteria() {
    const selectedCriteriaIds: Array<string> = [];
    this.searchService.getSelectedRows()
      .forEach((selectedRow: TableRow) => {
        selectedCriteriaIds.push(selectedRow.cells['searchId'].cVal);
      });
    if (selectedCriteriaIds.length > 0) {
      this.sharedServiceRegistry.confirmDialogService
        .confirmDialog(selectedCriteriaIds.length + ' record(s) will be deleted. Continue ?')
        .subscribe((isConfirmed: boolean) => {
          if (isConfirmed) {
            this.sharedServiceRegistry.savedSearchService
              .deleteSearchCriteria(selectedCriteriaIds)
              .subscribe((response: any) => {
                if (response && response['statusCode'] === 200) {
                  this.sharedServiceRegistry.alertService.clearAll().success(this
                    .coreServiceRegistry.resourceService.get('del_saved_criteria'));
                  this.searchService.performSearch();
                  selectedCriteriaIds
                    .forEach((selectedCriteriaId: string) => {
                      this.notifyEvent(DELETE_SEARCH, selectedCriteriaId);
                    });
                } else {
                  this.sharedServiceRegistry.alertService.error('Failed to delete criteria');
                }
              });
          }
        });
    } else {
      this.sharedServiceRegistry.alertService.clearAll().error(this
        .coreServiceRegistry.resourceService.get('del_saved_criteria_err'));
    }
  }

  private notifyEvent(type: number, item: string) {
    const event = new UserPreferenceEvent();
    event.type = type;
    event.item = item;
    event.source = 'saved_search';
    this.coreServiceRegistry.userPreferencesService.notifyEvent(event);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/search-criteria-popup/search-criteria-popup.component.ts